<div class="modal" *transloco="let t; read:'permit.gasfreeCert.addModal'">
    <div class="modal__content">
        <div class="modal__heading">{{ t("title") }}</div>

        <ha-input
            class="modal__search"
            [autofocus]="true"
            [formControl]="searchControl"
            [label]="t('searchLabel')"
            [readOnlyOnDisabled]="true"
            autocomplete="off"
            type="text"
        />

        <div *ngIf="isSearching" class="modal__state">{{ t("searching") }}</div>

        <div *ngIf="!isSearching && hasSearched && searchResults.length === 0" class="modal__state">
            {{ t("empty") }}
        </div>

        <div *ngIf="!isSearching && searchResults.length > 0" class="modal__results">
            <button
                *ngFor="let material of searchResults"
                class="modal__results__item"
                type="button"
                (click)="selectMaterial(material)">
                <span class="modal__results__item__name">{{ material.name }}</span>
                <span *ngIf="material.matchedSynonym" class="modal__results__item__matched-synonym">
                    {{ t("matchedSynonym", { synonym: material.matchedSynonym }) }}
                </span>
            </button>
        </div>
    </div>

    <div class="modal__actions">
        <button class="modal__actions__cancel" type="button" (click)="closeModal()">{{ t("cancel") }}</button>
    </div>
</div>
